import { Users, UsersForm } from '.';

export const usersRoutes = [
  {
    path: 'users',
    protected: true,
    element: Users,
    roles: ['USER_VIEW', 'USER_EDIT'],
  },
  {
    path: 'users/user-details',
    protected: true,
    element: UsersForm,
    roles: ['USER_VIEW', 'USER_EDIT'],
  },
];
